<template>
  <span class="dvr-content">
    <div class="d-flex align-center">
      <label class="page-label">DVR</label>
      <p style="font-weight: 400px; font-size: 14px; line-height: 21px;" class="feature-status">{{
        $t('message.pages.live.dvrActive') }}</p>
    </div>

    <p style="font-weight: 400px; font-size: 14px; line-height: 21px;" class="ma-0">{{
      $t('message.pages.live.dvrDescription') }}</p>
  </span>
</template>

<script>
// external imports

// internal imports

// API

// Components

export default {
  name: 'LiveDVR',
  props: {
    propsData: {
      type: Object,
      required: true,
    }
  },
  data: () => ({
    // ...
  }),
  mounted() {
    // ...
  },
  computed: {
    activeDvr: {
      get() { return this.propsData['activeDvr'] },
      set(value) { this.propsData['activeDvr'] = value }
    },
    // ...
  },
  methods: {
    // ...
  },
}
</script>

<style lang="scss" scoped>
.dvr-content {
  position: relative;
}

.feature-status {
  color: #4caf50;
  display: flex;
  align-items: center;
  position: absolute;
  top: -2;
  right: 0;
}

::v-deep {
  @import '@/assets/scss/src/new-live';

  .v-text-field fieldset,
  .v-text-field .v-input__control {
    border-color: var(--v-neutral-lighten2);
    color: var(--v-neutral-base);
  }
}

.bg-dark {

  .page-label {
    color: var(--v-primary-base) !important
  }
}</style>
